import { isBefore, subDays } from 'date-fns'

export type AtmosphereTransport = 'websocket' | 'long-polling'

export interface AtmosphereTransportManagerModel {
  currentTransport: AtmosphereTransport
  lastSuccessfulTransportUpdate: Date
}

export class AtmosphereTransportManager {
  private static instance: AtmosphereTransportManager
  private readonly storageKey = 'atmosphere-transport'

  private constructor() {
    const cache = this.loadFromStorage()
    if (!cache || isBefore(new Date(cache.lastSuccessfulTransportUpdate), subDays(new Date(), 7))) {
      this.reset()
    }
  }

  static getInstance(): AtmosphereTransportManager {
    if (!AtmosphereTransportManager.instance) {
      AtmosphereTransportManager.instance = new AtmosphereTransportManager()
    }
    return AtmosphereTransportManager.instance
  }

  getCurrentTransport(): AtmosphereTransport {
    const cache = this.loadFromStorage()
    return cache?.currentTransport || 'websocket'
  }

  setCurrentTransport(transport: AtmosphereTransport): void {
    const cache = this.loadFromStorage()
    if (transport !== cache?.currentTransport) {
      this.saveToStorage({
        currentTransport: transport,
        lastSuccessfulTransportUpdate: new Date(),
      })
    }
  }

  reset(): void {
    this.saveToStorage({
      currentTransport: 'websocket',
      lastSuccessfulTransportUpdate: new Date(),
    })
  }

  private loadFromStorage(): AtmosphereTransportManagerModel | null {
    try {
      const stored = localStorage.getItem(this.storageKey)
      if (!stored) return null

      const parsed = JSON.parse(stored)
      return {
        currentTransport: parsed.currentTransport,
        lastSuccessfulTransportUpdate: new Date(parsed.lastSuccessfulTransportUpdate),
      }
    } catch {
      return null
    }
  }

  private saveToStorage(cache: AtmosphereTransportManagerModel): void {
    try {
      localStorage.setItem(this.storageKey, JSON.stringify(cache))
    } catch {
      // Ignore localStorage errors
    }
  }
}
